"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Tag;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _uiIcons = require("@blueprism/ui-icons");

var _Box = _interopRequireDefault(require("../../layout/Box"));

var _IconButton = _interopRequireDefault(require("../IconButton"));

var _colorUtils = require("../../utils/colorUtils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

//eslint-disable-next-line
var HashIcon = function HashIcon(_ref) {
  var size = _ref.size,
      color = _ref.color;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 8 8"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.47312 5.74725H3.05376L2.62366 8H1.85484L2.28495 5.74725H1V4.99451H2.42473L2.7957 3.04945H1.4086V2.28571H2.94086L3.38172 0H4.15054L3.70968 2.28571H5.12903L5.56989 0H6.34409L5.90323 2.28571H7V3.04945H5.75806L5.3871 4.99451H6.59677V5.74725H5.24731L4.8172 8H4.04301L4.47312 5.74725ZM3.19355 4.99451H4.6129L4.98387 3.04945H3.56452L3.19355 4.99451Z",
    fill: "".concat(color)
  }));
};

var bounceIn = (0, _styledComponents.keyframes)(["0%{opacity:0;transform:scale(0);}50%{opacity:1;transform:scale(1.1);}100%{opacity:1;tranform:scale(1);}"]);
var Container = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Tag__Container",
  componentId: "b91jsx-0"
})(function (_ref2) {
  var theme = _ref2.theme,
      disableAnimation = _ref2.disableAnimation;
  return (0, _styledComponents.css)(["min-height:2.75rem;padding:0 3.25rem 0 0.5rem;margin-bottom:2px;border-radius:1.5rem;min-width:4rem;background:", ";width:max-content;box-shadow:0 2px 1px -1px ", ";display:flex;align-items:center;position:relative;", ""], theme.color.paper, theme.color.action, !disableAnimation && (0, _styledComponents.css)(["animation:", " 0.3s ease;"], bounceIn));
});
var PositionedButton = (0, _styledComponents["default"])(_IconButton["default"]).withConfig({
  displayName: "Tag__PositionedButton",
  componentId: "b91jsx-1"
})(["position:absolute;right:0;top:0;"]);
var IconContainer = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Tag__IconContainer",
  componentId: "b91jsx-2"
})(["padding-right:0.25rem;display:flex;align-items:center;"]);
/**
 The **Tag** component renders is `children` text inside a visible container with a `hash` icon and **IconButton**. It would typically be used to within a list, giving the user the option to remove the **Tag**s via the **IconButton**. By default, it renders a `span`, however it can be rendered as one of a number of other element via the `element` prop.
 */

var _ref4 = /*#__PURE__*/_react["default"].createElement(_uiIcons.Cross, {
  size: 24
});

function Tag(_ref3) {
  var children = _ref3.children,
      _ref3$element = _ref3.element,
      element = _ref3$element === void 0 ? 'div' : _ref3$element,
      _ref3$disableAnimatio = _ref3.disableAnimation,
      disableAnimation = _ref3$disableAnimatio === void 0 ? false : _ref3$disableAnimatio,
      _ref3$onButtonClick = _ref3.onButtonClick,
      onButtonClick = _ref3$onButtonClick === void 0 ? function () {} : _ref3$onButtonClick;

  var theme = _react["default"].useContext(_styledComponents.ThemeContext);

  function handleClick(event) {
    onButtonClick(event, children);
  }

  return /*#__PURE__*/_react["default"].createElement(Container, {
    element: element,
    disableAnimation: disableAnimation
  }, /*#__PURE__*/_react["default"].createElement(IconContainer, null, /*#__PURE__*/_react["default"].createElement(HashIcon, {
    size: 16,
    color: (0, _colorUtils.hexToRGBA)(theme.color.action, 0.8)
  })), children, /*#__PURE__*/_react["default"].createElement(PositionedButton, {
    "aria-label": "remove ".concat(children, " tag"),
    icon: _ref4,
    onClick: handleClick
  }));
}